import { TranslateFunction } from '@griply/types';

export const getPremiumOptionLabel = (
  label: string,
  allowed: boolean,
  t: TranslateFunction,
): string => (allowed ? label : t('general.premium-option', { label }));
